export interface FieldTypeOption {
  label: string;
  selectValue: string;
}

export const availableFieldTypes: readonly FieldTypeOption[] = [
  {
    label: 'Text',
    selectValue: 'TT',
  },
  {
    label: 'Text Area',
    selectValue: 'TA',
  },
  {
    label: 'HTML Snippet',
    selectValue: 'HT',
  },
  {
    label: 'Pulldown',
    selectValue: 'PD',
  },
  {
    label: 'Checkbox',
    selectValue: 'CB',
  },
  {
    label: 'Radio Button',
    selectValue: 'RD',
  },
  {
    label: 'Date',
    selectValue: 'DATE',
  },
  // {
  //   label: 'Table',
  //   selectValue: 'TB',
  // },
  {
    label: 'Multi Select',
    selectValue: 'MS',
  },
];

export interface DatePrecisionOption extends FieldTypeOption {
  description: string;
}

export const datePrecisionOptions: readonly DatePrecisionOption[] = [
  // { label: 'Date and Time', selectValue: 'DT', description: 'Full date with time — e.g. "Mar 15, 2024 2:30 PM"' },
  { label: 'Date Only', selectValue: 'DA', description: 'A specific day — e.g. "Mar 15, 2024"' },
  { label: 'Year and Month', selectValue: 'YM', description: 'No specific day — e.g. "Mar 2024"' },
  { label: 'Year Only', selectValue: 'YO', description: 'Just the year — e.g. "2024"' },
];

// Keep in sync with backend: backend/common/const.py VALID_DATE_STYLES_BY_FIELD_TYPE
export interface DateDisplayStyleOption {
  label: string;
  selectValue: string;
  example: string;
}

export const dateDisplayStyleOptionsDA: readonly DateDisplayStyleOption[] = [
  { label: 'ISO', selectValue: 'iso', example: '2020-03-13' },
  { label: 'US', selectValue: 'us', example: '3/13/2020' },
  { label: 'US Padded', selectValue: 'us-padded', example: '03-13-2020' },
  { label: 'European', selectValue: 'eu', example: '13/3/2020' },
  { label: 'Long', selectValue: 'long', example: 'March 13, 2020' },
  { label: 'Long European', selectValue: 'long-eu', example: '13 March 2020' },
  { label: 'Abbreviated', selectValue: 'abbr', example: 'Mar 13, 2020' },
];

export const dateDisplayStyleOptionsYM: readonly DateDisplayStyleOption[] = [
  { label: 'ISO', selectValue: 'iso', example: '2020-03' },
  { label: 'Short', selectValue: 'short', example: '3/2020' },
  { label: 'Long', selectValue: 'long', example: 'March 2020' },
  { label: 'Abbreviated', selectValue: 'abbr', example: 'Mar 2020' },
];

export const getStyleOptionsForPrecision = (precision: string): readonly DateDisplayStyleOption[] | null => {
  if (precision === 'DA' || precision === 'DT') return dateDisplayStyleOptionsDA;
  if (precision === 'YM') return dateDisplayStyleOptionsYM;
  return null;
};
